import type { Station } from '@/types';

/**
 * Liste des villes/gares desservies par EuroRail.
 * 219 villes dans 30 pays européens.
 *
 * Coordonnées : [latitude, longitude] (WGS84).
 * Format compact pensé pour minimiser le poids en bundle.
 *
 * Pour ajouter une ville :
 *   1. Ajouter l'entrée ici (id stable et minuscule, sans espace)
 *   2. Ajouter ses arêtes dans `edges.ts`
 *   3. Le graphe est reconstruit automatiquement au runtime (`graph.ts`)
 */
export const STATIONS: Station[] = [
  { id: "lyon", name: "Lyon", coords: [45.7640, 4.8357] },
  { id: "paris", name: "Paris", coords: [48.8566, 2.3522] },
  { id: "marseille", name: "Marseille", coords: [43.2965, 5.3698] },
  { id: "bordeaux", name: "Bordeaux", coords: [44.8378, -0.5792] },
  { id: "toulouse", name: "Toulouse", coords: [43.6047, 1.4442] },
  { id: "nantes", name: "Nantes", coords: [47.2184, -1.5536] },
  { id: "rennes", name: "Rennes", coords: [48.1173, -1.6778] },
  { id: "lille", name: "Lille", coords: [50.6292, 3.0573] },
  { id: "strasbourg", name: "Strasbourg", coords: [48.5734, 7.7521] },
  { id: "nice", name: "Nice", coords: [43.7102, 7.2620] },
  { id: "montpellier", name: "Montpellier", coords: [43.6108, 3.8767] },
  { id: "avignon", name: "Avignon", coords: [43.9493, 4.8055] },
  { id: "perpignan", name: "Perpignan", coords: [42.6886, 2.8946] },
  { id: "dijon", name: "Dijon", coords: [47.3220, 5.0415] },
  { id: "grenoble", name: "Grenoble", coords: [45.1885, 5.7245] },
  { id: "annecy", name: "Annecy", coords: [45.8992, 6.1294] },
  { id: "chambery", name: "Chambéry", coords: [45.5646, 5.9178] },
  { id: "clermont", name: "Clermont-Ferrand", coords: [45.7772, 3.0870] },
  { id: "metz", name: "Metz", coords: [49.1193, 6.1757] },
  { id: "nancy", name: "Nancy", coords: [48.6921, 6.1844] },
  { id: "reims", name: "Reims", coords: [49.2583, 4.0317] },
  { id: "tours", name: "Tours", coords: [47.3941, 0.6848] },
  { id: "poitiers", name: "Poitiers", coords: [46.5802, 0.3404] },
  { id: "brest", name: "Brest", coords: [48.3904, -4.4861] },
  { id: "bruxelles", name: "Bruxelles", coords: [50.8503, 4.3517] },
  { id: "anvers", name: "Anvers", coords: [51.2194, 4.4025] },
  { id: "liege", name: "Liège", coords: [50.6326, 5.5797] },
  { id: "luxembourg", name: "Luxembourg", coords: [49.6116, 6.1319] },
  { id: "amsterdam", name: "Amsterdam", coords: [52.3676, 4.9041] },
  { id: "rotterdam", name: "Rotterdam", coords: [51.9244, 4.4777] },
  { id: "utrecht", name: "Utrecht", coords: [52.0907, 5.1214] },
  { id: "geneve", name: "Genève", coords: [46.2044, 6.1432] },
  { id: "lausanne", name: "Lausanne", coords: [46.5197, 6.6323] },
  { id: "berne", name: "Berne", coords: [46.9480, 7.4474] },
  { id: "zurich", name: "Zurich", coords: [47.3769, 8.5417] },
  { id: "bale", name: "Bâle", coords: [47.5596, 7.5886] },
  { id: "lugano", name: "Lugano", coords: [46.0037, 8.9511] },
  { id: "interlaken", name: "Interlaken", coords: [46.6863, 7.8632] },
  { id: "francfort", name: "Francfort", coords: [50.1109, 8.6821] },
  { id: "cologne", name: "Cologne", coords: [50.9375, 6.9603] },
  { id: "munich", name: "Munich", coords: [48.1351, 11.5820] },
  { id: "stuttgart", name: "Stuttgart", coords: [48.7758, 9.1829] },
  { id: "berlin", name: "Berlin", coords: [52.5200, 13.4050] },
  { id: "hambourg", name: "Hambourg", coords: [53.5511, 9.9937] },
  { id: "hanovre", name: "Hanovre", coords: [52.3759, 9.7320] },
  { id: "leipzig", name: "Leipzig", coords: [51.3397, 12.3731] },
  { id: "dresde", name: "Dresde", coords: [51.0504, 13.7373] },
  { id: "nuremberg", name: "Nuremberg", coords: [49.4521, 11.0767] },
  { id: "dusseldorf", name: "Düsseldorf", coords: [51.2277, 6.7735] },
  { id: "vienne", name: "Vienne", coords: [48.2082, 16.3738] },
  { id: "salzbourg", name: "Salzbourg", coords: [47.8095, 13.0550] },
  { id: "innsbruck", name: "Innsbruck", coords: [47.2692, 11.4041] },
  { id: "graz", name: "Graz", coords: [47.0707, 15.4395] },
  { id: "barcelone", name: "Barcelone", coords: [41.3851, 2.1734] },
  { id: "madrid", name: "Madrid", coords: [40.4168, -3.7038] },
  { id: "valence_es", name: "Valence (ES)", coords: [39.4699, -0.3763] },
  { id: "seville", name: "Séville", coords: [37.3891, -5.9845] },
  { id: "saragosse", name: "Saragosse", coords: [41.6488, -0.8891] },
  { id: "bilbao", name: "Bilbao", coords: [43.2630, -2.9350] },
  { id: "malaga", name: "Malaga", coords: [36.7213, -4.4214] },
  { id: "milan", name: "Milan", coords: [45.4642, 9.1900] },
  { id: "turin", name: "Turin", coords: [45.0703, 7.6869] },
  { id: "venise", name: "Venise", coords: [45.4408, 12.3155] },
  { id: "florence", name: "Florence", coords: [43.7696, 11.2558] },
  { id: "rome", name: "Rome", coords: [41.9028, 12.4964] },
  { id: "naples", name: "Naples", coords: [40.8518, 14.2681] },
  { id: "bologne", name: "Bologne", coords: [44.4949, 11.3426] },
  { id: "verone", name: "Vérone", coords: [45.4384, 10.9916] },
  { id: "genes", name: "Gênes", coords: [44.4056, 8.9463] },
  { id: "trieste", name: "Trieste", coords: [45.6495, 13.7768] },
  { id: "londres", name: "Londres", coords: [51.5074, -0.1278] },
  { id: "manchester", name: "Manchester", coords: [53.4808, -2.2426] },
  { id: "edimbourg", name: "Édimbourg", coords: [55.9533, -3.1883] },
  { id: "birmingham", name: "Birmingham", coords: [52.4862, -1.8904] },
  { id: "copenhague", name: "Copenhague", coords: [55.6761, 12.5683] },
  { id: "malmo", name: "Malmö", coords: [55.6049, 13.0038] },
  { id: "stockholm", name: "Stockholm", coords: [59.3293, 18.0686] },
  { id: "goteborg", name: "Göteborg", coords: [57.7089, 11.9746] },
  { id: "oslo", name: "Oslo", coords: [59.9139, 10.7522] },
  { id: "prague", name: "Prague", coords: [50.0755, 14.4378] },
  { id: "brno", name: "Brno", coords: [49.1951, 16.6068] },
  { id: "bratislava", name: "Bratislava", coords: [48.1486, 17.1077] },
  { id: "budapest", name: "Budapest", coords: [47.4979, 19.0402] },
  { id: "varsovie", name: "Varsovie", coords: [52.2297, 21.0122] },
  { id: "cracovie", name: "Cracovie", coords: [50.0647, 19.9450] },
  { id: "zagreb", name: "Zagreb", coords: [45.8150, 15.9819] },
  { id: "ljubljana", name: "Ljubljana", coords: [46.0569, 14.5058] },
  { id: "belgrade", name: "Belgrade", coords: [44.7866, 20.4489] },
  { id: "bucarest", name: "Bucarest", coords: [44.4268, 26.1025] },
  { id: "sofia", name: "Sofia", coords: [42.6977, 23.3219] },
  { id: "gdansk", name: "Gdańsk", coords: [54.3520, 18.6466] },
  { id: "poznan", name: "Poznań", coords: [52.4064, 16.9252] },
  { id: "wroclaw", name: "Wrocław", coords: [51.1079, 17.0385] },
  { id: "lodz", name: "Łódź", coords: [51.7592, 19.4560] },
  { id: "katowice", name: "Katowice", coords: [50.2649, 19.0238] },
  { id: "lublin", name: "Lublin", coords: [51.2465, 22.5684] },
  { id: "szczecin", name: "Szczecin", coords: [53.4285, 14.5528] },
  { id: "ostrava", name: "Ostrava", coords: [49.8209, 18.2625] },
  { id: "plzen", name: "Plzeň", coords: [49.7384, 13.3736] },
  { id: "kosice", name: "Košice", coords: [48.7164, 21.2611] },
  { id: "zilina", name: "Žilina", coords: [49.2231, 18.7394] },
  { id: "debrecen", name: "Debrecen", coords: [47.5316, 21.6273] },
  { id: "szeged", name: "Szeged", coords: [46.2530, 20.1414] },
  { id: "gyor", name: "Győr", coords: [47.6875, 17.6504] },
  { id: "pecs", name: "Pécs", coords: [46.0727, 18.2330] },
  { id: "cluj", name: "Cluj-Napoca", coords: [46.7712, 23.6236] },
  { id: "brasov", name: "Brașov", coords: [45.6580, 25.6012] },
  { id: "sibiu", name: "Sibiu", coords: [45.7983, 24.1255] },
  { id: "timisoara", name: "Timișoara", coords: [45.7489, 21.2087] },
  { id: "iasi", name: "Iași", coords: [47.1585, 27.6014] },
  { id: "constanta", name: "Constanța", coords: [44.1598, 28.6348] },
  { id: "plovdiv", name: "Plovdiv", coords: [42.1354, 24.7453] },
  { id: "varna", name: "Varna", coords: [43.2141, 27.9147] },
  { id: "bourgas", name: "Bourgas", coords: [42.5048, 27.4626] },
  { id: "rousse", name: "Roussé", coords: [43.8564, 25.9657] },
  { id: "sarajevo", name: "Sarajevo", coords: [43.8563, 18.4131] },
  { id: "split", name: "Split", coords: [43.5081, 16.4402] },
  { id: "dubrovnik", name: "Dubrovnik", coords: [42.6507, 18.0944] },
  { id: "rijeka", name: "Rijeka", coords: [45.3271, 14.4422] },
  { id: "novi_sad", name: "Novi Sad", coords: [45.2671, 19.8335] },
  { id: "nis", name: "Niš", coords: [43.3209, 21.8958] },
  { id: "podgorica", name: "Podgorica", coords: [42.4304, 19.2594] },
  { id: "skopje", name: "Skopje", coords: [41.9981, 21.4254] },
  { id: "tirana", name: "Tirana", coords: [41.3275, 19.8187] },
  { id: "pristina", name: "Pristina", coords: [42.6629, 21.1655] },
  { id: "tallinn", name: "Tallinn", coords: [59.4370, 24.7536] },
  { id: "riga", name: "Riga", coords: [56.9496, 24.1052] },
  { id: "vilnius", name: "Vilnius", coords: [54.6872, 25.2797] },
  { id: "kaunas", name: "Kaunas", coords: [54.8985, 23.9036] },
  { id: "lviv", name: "Lviv", coords: [49.8397, 24.0297] },
  { id: "kiev", name: "Kyiv", coords: [50.4501, 30.5234] },
  { id: "chisinau", name: "Chișinău", coords: [47.0105, 28.8638] },
  { id: "thessalonique", name: "Thessalonique", coords: [40.6401, 22.9444] },
  { id: "athenes", name: "Athènes", coords: [37.9838, 23.7275] },
  { id: "istanbul", name: "Istanbul", coords: [41.0082, 28.9784] },
  { id: "helsinki", name: "Helsinki", coords: [60.1699, 24.9384] },
  { id: "land_de_breme", name: "land de Brême", coords: [53.1333, 8.7333] },
  { id: "dortmund", name: "Dortmund", coords: [51.5139, 7.4653] },
  { id: "essen", name: "Essen", coords: [51.4508, 7.0131] },
  { id: "bielefeld", name: "Bielefeld", coords: [52.0167, 8.5333] },
  { id: "munster", name: "Münster", coords: [51.9625, 7.6256] },
  { id: "mannheim", name: "Mannheim", coords: [49.4878, 8.4661] },
  { id: "karlsruhe", name: "Karlsruhe", coords: [49.0167, 8.4] },
  { id: "augsbourg", name: "Augsbourg", coords: [48.3689, 10.8978] },
  { id: "wiesbaden", name: "Wiesbaden", coords: [50.0825, 8.24] },
  { id: "aix_la_chapelle", name: "Aix-la-Chapelle", coords: [50.7762, 6.0838] },
  { id: "brunswick", name: "Brunswick", coords: [52.2692, 10.5211] },
  { id: "chemnitz", name: "Chemnitz", coords: [50.8333, 12.9167] },
  { id: "kiel", name: "Kiel", coords: [54.3233, 10.1394] },
  { id: "halle_sur_saale", name: "Halle-sur-Saale", coords: [51.4828, 11.9697] },
  { id: "magdebourg", name: "Magdebourg", coords: [52.1316, 11.64] },
  { id: "fribourg_en_brisgau", name: "Fribourg-en-Brisgau", coords: [47.995, 7.85] },
  { id: "lubeck", name: "Lübeck", coords: [53.8697, 10.6864] },
  { id: "erfurt", name: "Erfurt", coords: [50.9781, 11.0289] },
  { id: "rostock", name: "Rostock", coords: [54.0833, 12.1333] },
  { id: "cassel", name: "Cassel", coords: [51.3158, 9.4979] },
  { id: "sarrebruck", name: "Sarrebruck", coords: [49.2333, 7] },
  { id: "oldenbourg", name: "Oldenbourg", coords: [53.1439, 8.2139] },
  { id: "osnabruck", name: "Osnabrück", coords: [52.2789, 8.0431] },
  { id: "darmstadt", name: "Darmstadt", coords: [49.8667, 8.65] },
  { id: "ratisbonne", name: "Ratisbonne", coords: [49.0167, 12.0833] },
  { id: "linz", name: "Linz", coords: [48.3058, 14.2864] },
  { id: "gand", name: "Gand", coords: [51.0536, 3.7253] },
  { id: "aarhus", name: "Aarhus", coords: [56.1564, 10.2097] },
  { id: "odense", name: "Odense", coords: [55.4, 10.3833] },
  { id: "alicante", name: "Alicante", coords: [38.3453, -0.4831] },
  { id: "murcia", name: "Murcia", coords: [37.9834, -1.1304] },
  { id: "ville_de_burgos", name: "Ville de Burgos", coords: [42.3411, -3.7042] },
  { id: "badajoz", name: "Badajoz", coords: [38.8779, -6.9706] },
  { id: "turku", name: "Turku", coords: [60.4517, 22.2669] },
  { id: "toulon", name: "Toulon", coords: [43.125, 5.9306] },
  { id: "saint_etienne", name: "Saint-Étienne", coords: [45.4339, 4.3897] },
  { id: "le_havre", name: "Le Havre", coords: [49.4942, 0.1081] },
  { id: "angers", name: "Angers", coords: [47.4728, -0.5556] },
  { id: "nimes", name: "Nîmes", coords: [43.8383, 4.3597] },
  { id: "palerme", name: "Palerme", coords: [38.1157, 13.3613] },
  { id: "bari", name: "Bari", coords: [41.1253, 16.8667] },
  { id: "catane", name: "Catane", coords: [37.5027, 15.0873] },
  { id: "messine", name: "Messine", coords: [38.1936, 15.5542] },
  { id: "padoue", name: "Padoue", coords: [45.4078, 11.8733] },
  { id: "parme", name: "Parme", coords: [44.8015, 10.328] },
  { id: "brescia", name: "Brescia", coords: [45.5389, 10.2203] },
  { id: "tarente", name: "Tarente", coords: [40.4711, 17.2431] },
  { id: "modene", name: "Modène", coords: [44.6458, 10.9257] },
  { id: "reggio_d_emilie", name: "Reggio d'Émilie", coords: [44.7, 10.6333] },
  { id: "perouse", name: "Pérouse", coords: [43.1119, 12.3885] },
  { id: "ravenne", name: "Ravenne", coords: [44.4161, 12.2017] },
  { id: "livourne", name: "Livourne", coords: [43.55, 10.3167] },
  { id: "eindhoven", name: "Eindhoven", coords: [51.4344, 5.4842] },
  { id: "groningue", name: "Groningue", coords: [53.2189, 6.5675] },
  { id: "tilbourg", name: "Tilbourg", coords: [51.5575, 5.0906] },
  { id: "arnhem", name: "Arnhem", coords: [51.9833, 5.9167] },
  { id: "enschede", name: "Enschede", coords: [52.2225, 6.8925] },
  { id: "bydgoszcz", name: "Bydgoszcz", coords: [53.1167, 18] },
  { id: "bia_ystok", name: "Białystok", coords: [53.1324, 23.1687] },
  { id: "czestochowa", name: "Częstochowa", coords: [50.8096, 19.1222] },
  { id: "radom", name: "Radom", coords: [51.4167, 21.15] },
  { id: "torun", name: "Toruń", coords: [53.0144, 18.6014] },
  { id: "rzeszow", name: "Rzeszów", coords: [50.0411, 21.9989] },
  { id: "kielce", name: "Kielce", coords: [50.8725, 20.6319] },
  { id: "bielsko_bia_a", name: "Bielsko-Biała", coords: [49.8225, 19.0444] },
  { id: "lisbonne", name: "Lisbonne", coords: [38.708, -9.139] },
  { id: "porto", name: "Porto", coords: [41.15, -8.6108] },
  { id: "braga", name: "Braga", coords: [41.5503, -8.42] },
  { id: "oradea", name: "Oradea", coords: [47.0722, 21.9211] },
  { id: "ploiesti", name: "Ploiești", coords: [44.9411, 26.0225] },
  { id: "glasgow", name: "Glasgow", coords: [55.8611, -4.25] },
  { id: "leeds", name: "Leeds", coords: [53.7975, -1.5436] },
  { id: "sheffield", name: "Sheffield", coords: [53.3808, -1.4703] },
  { id: "liverpool", name: "Liverpool", coords: [53.4072, -2.9917] },
  { id: "bristol", name: "Bristol", coords: [51.4536, -2.5975] },
  { id: "cardiff", name: "Cardiff", coords: [51.4817, -3.1792] },
  { id: "leicester", name: "Leicester", coords: [52.6361, -1.1331] },
  { id: "coventry", name: "Coventry", coords: [52.4167, -1.5167] },
  { id: "newcastle_upon_tyne", name: "Newcastle upon Tyne", coords: [54.9778, -1.6133] },
  { id: "nottingham", name: "Nottingham", coords: [52.955, -1.1492] },
  { id: "stoke_on_trent", name: "Stoke-on-Trent", coords: [53, -2.1833] },
  { id: "swindon", name: "Swindon", coords: [51.5583, -1.7811] },
  { id: "york", name: "York", coords: [53.95, -1.0833] },
];
